(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
      (function(){
        const images = document.querySelectorAll('.mw-image-gallery a');
        const modal = document.querySelector('.mw-modal');
        const modalImage = modal.querySelector('img');
        let currentIndex = 0;
        
        // Open modal popup and show clicked image
        function showModal(index) {
          if(window.innerWidth > 749){
            modalImage.src = images[index].dataset.desktop;
          } else {
            modalImage.src = images[index].dataset.mobile;  
          }    
          modal.classList.add('show');
          currentIndex = index;
        }
        
        // Hide modal popup
        function hideModal() {
          modal.classList.remove('show');
        }
        
        // Show previous image in gallery
        function showPrevImage(e) {
          e.stopPropagation()
          if (currentIndex === 0) {
            showModal(images.length - 1);
          } else {
            showModal(currentIndex - 1);
          }
        }
        
        // Show next image in gallery
        function showNextImage(e) {
          e.stopPropagation()
          if (currentIndex === images.length - 1) {
            showModal(0);
          } else {
            showModal(currentIndex + 1);
          }
        }
        
        // Add click event listeners to all images
        images.forEach((image, index) => {
          image.addEventListener('click', (e) => {
            e.preventDefault()
            showModal(index);
          });
        });  
          
        // Add click event listeners to modal navigation arrows
        const prevArrow = modal.querySelector('.mw-modal-prev');
        prevArrow.addEventListener('click', showPrevImage);
        
        const nextArrow = modal.querySelector('.mw-modal-next');
        nextArrow.addEventListener('click', showNextImage);
        
        // Add click event listener to modal background to hide it
        modal.addEventListener('click', hideModal);
      
        
      })()
      
  } catch(e) { console.error(e); }
})();
})();
